import { BaseModel } from '../base.model';

/**
 * One job-cost transaction row for the in-app Cost Detail report (WI 30860),
 * the reliable replacement for the flaky SSRS "VP Cost Detail Report".
 *
 * Property names are PascalCase and mirror the server DTO
 * (apps/viewpoint-api/UPS.Viewpoint.DTO/Common/CostDetailDto.cs) one-for-one, so
 * a grid `field="..."` binds directly and OData grouping (which is field-name
 * case-sensitive server-side, hence the PascalCase client) resolves. Every
 * column is nullable: the source query LEFT JOINs the description tables.
 */
export class CostDetailDto extends BaseModel {
  // --- Cost transaction ---
  public ActualHours: number | null;
  public ActualCost: number | null;
  public CostTrans: number | null;
  public Mth: Date | null;
  public ActualDate: Date | null;
  public JCTransType: string | null;
  public Job: string | null;
  public Phase: string | null;
  public CostType: number | null;
  public JCCo: number | null;
  public DetlDesc: string | null;
  public POItemDesc: string | null;
  public Vendor: number | null;
  public Craft: string | null;
  public Class: string | null;
  public EMEquip: string | null;
  public Material: string | null;
  public Employee: number | null;
  public APRef: string | null;
  public EarnFactor: number | null;
  public PO: string | null;
  public JBBillMonth: Date | null;
  public JBBillStatus: string | null;
  public RevenueCode: string | null;
  public Shift: number | null;

  // --- Description joins ---
  public CostTypeDesc: string | null;
  public Abbreviation: string | null;
  public JobDescription: string | null;
  public PhaseDesc: string | null;
  public Name: string | null;
  public LastName: string | null;
  public PRCo: number | null;
  public EquipDesc: string | null;
  public MatlDesc: string | null;
  public Invoice: string | null;
  public InvStatus: string | null;

  constructor(o: any = null) {
    super(o);
  }
}
